import { Form, Button, Input, Select, Radio, Checkbox } from "antd";
import { useState } from "react";
import { store } from "../../../../../../../redux";
import { useDispatch } from "react-redux"
import { actionDefinitions } from "./actionDefinitions";
import { getKeycloackToken } from "../../../../../../../redux/actions/auth";
import { setDraft } from "../../../../../../../redux/actions/skill";
import $ from 'jquery'



export function GenAIConfigurer(props) {
    const [prompt, setPrompt] = useState("")
    const dispatch = useDispatch();
    const {
        skillReducer: { trainDraft },
    } = store.getState();

    function pick(obj, keys) {
        return keys.reduce((result, key) => {
          if (obj.hasOwnProperty(key)) {
            result[key] = obj[key];
          }
          return result;
        }, {});
      }

    function getActionTypes(data) {
        const actionTypes = [];
        let done = false

        function traverseChildren(children) {
            if (!children || done) return; // Handle cases where 'children' might be missing
            if (children.id === props.nodeData.id) {
                done = true
                return
            }

            children.forEach(child => {
                if (child.actionType) {
                    actionTypes.push(child.actionType || child.type);
                }
                traverseChildren(child.children); // Recursion for nested structures
            });
        }

        data.forEach(item => {
            if (done) return
            // actionTypes.push(item.actionType || item.type)
            traverseChildren(item.children)
        });
        return actionTypes;
    }

    const configure = async () => {
        const actions = getActionTypes(trainDraft.RAW_DATA.actions).slice(0, -1)
        const outputSchemas = actions.map((actionType, idx) => {
            const actionDfn = actionDefinitions.find((action) => action.type === actionType)
            if (!actionDfn) return undefined
            delete actionDfn?.supervitySchema?.output?.$schema
            return { type: actionDfn.type, description: actionDfn.description, outputSchema: actionDfn?.supervitySchema?.output }
        }).filter(schema => !!schema)

        const currentAction = actionDefinitions.find((action) => action.type === props.actionType)
        delete currentAction?.supervitySchema?.input?.$schema

        const token = await getKeycloackToken()
        const response = await fetch(`${process.env.REACT_APP_BOT_SERVICE_URL}/v2/skill/rpa/action`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                prompt: prompt,
                inputSchema: {
                    type: currentAction.type,
                    description: currentAction.description,
                    inputSchema: currentAction?.supervitySchema?.input
                },
                outputSchemas
            })
        })
        if (!response.ok) throw new Error("Action configuration failed")
        const resJson = await response.json()

        console.log(props.nodes, props.nodeData.id, resJson.config)
        props.setNodeConfig(prevState => {
            console.log(">>>>>", prevState, resJson)
            return {
                ...prevState,
                ...resJson.config
            }
        })
        // const newActions = findAndUpdate(props.nodes, props.nodeData.id, { ...props.nodeData, ...resJson.config });
        // store.dispatch(
        //     setDraft({
        //         ...trainDraft,
        //         RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        //     })
        // );
        // Object.keys(resJson.config).forEach(key => {
        //     $(`#${key}`).val(resJson.config[key])
        // })
    }

    const findAndUpdate = (arr, id, payload) => {
        let found = arr.findIndex((i) => i.id == id);
        if (found > -1) {
            arr[found] = { ...arr[found], ...payload };
        } else {
            arr.forEach((element) => {
                if (
                    [
                        "branch",
                        "condition",
                        "loop",
                        "loop-nodes",
                        "try",
                        "try-catch-node",
                        "review",
                        "review-node",
                    ].includes(element.type)
                ) {
                    findAndUpdate(element.children, id, payload);
                }
            });
        }
        return arr;
    };

    return (
        <div className="genAi-block" >
            <Input.TextArea rows={4} onChange={(e) => setPrompt(e.target.value)} value={prompt} />
            <Button onClick={() => configure()} type="primary">Generate</Button>
        </div>
    )
}